function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4390"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4390"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $0056b85d938852dc$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"f9fpV":"index.00800664.js","hfd23":"icons.c14567a0.svg"}'));

//business logic + state + http lib
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $ba30e20475feac5a$export$5feaddb1377b7f5e = 10;


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        resultsPerPage: (0, $ba30e20475feac5a$export$5feaddb1377b7f5e),
        page: 1
    }
};
const $0f1d4402dffacf5b$export$b96725c7a035d60b = async function(newURL) {
    try {
        const res = await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}${newURL}`);
        const data = await res.json();
        let { recipe: recipe  } = data.data;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = {
            id: recipe.id,
            title: recipe.title,
            publisher: recipe.publisher,
            cookingTime: recipe.cooking_time,
            sourceUrl: recipe.source_url,
            image: recipe.image_url,
            servings: recipe.servings,
            ingredients: recipe.ingredients
        };
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$202b8e5cb363a0c4 = async function(query) {
    try {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.query = query;
        const res = await fetch(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?search=${query}`);
        const data = await res.json();
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = data.data.recipes.map((recipe)=>{
            return {
                id: recipe.id,
                title: recipe.title,
                publisher: recipe.publisher,
                cookingTime: recipe.cooking_time,
                image: recipe.image_url
            };
        });
        console.log("results", $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results);
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$b06b94e1e883c50a = (page = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page)=>{
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage;
    const end = page * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.slice(start, end);
};


var $cb59c201e168fdfe$exports = {};

$cb59c201e168fdfe$exports = new URL((parcelRequire("27Lyk")).resolve("hfd23"), import.meta.url).toString();


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    _data;
    render(data) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        console.log("_data", this._data);
        const markup = this._generateMarkup();
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    renderSpinner() {
        const spinnerMarkup = `<div class="spinner">
    <svg>
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports)))}#icon-loader"></use>
    </svg>
  </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", spinnerMarkup);
    }
    renderError(message = this._errorMessage) {
        console.log("message", message);
        const errorMarkup = `<div class="error">
    <div>
      <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports)))}#icon-alert-triangle"></use>
      </svg>
    </div>
    <p>${message}</p>
  </div>`;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", errorMarkup);
    }
}



class $e95330fac959b1b1$var$RecipeView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    // private properties
    _parentElement = document.querySelector(".recipe");
    _errorMessage = `Sorry we couldn't find the recipe. Please try another one!`;
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((event)=>window.addEventListener(event, handler));
    }
    _generateMarkup() {
        return `
    <figure class="recipe__fig">
      <img src="${this._data.image}" alt="Tomato" class="recipe__img" />
      <h1 class="recipe__title">
        <span>${this._data.title}</span>
      </h1>
    </figure>

    <div class="recipe__details">
      <div class="recipe__info">
        <svg class="recipe__info-icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-clock"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
        <span class="recipe__info-text">minutes</span>
      </div>
      <div class="recipe__info">
        <svg class="recipe__info-icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-users"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
        <span class="recipe__info-text">servings</span>

        <div class="recipe__info-buttons">
          <button class="btn--tiny btn--increase-servings">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-minus-circle"></use>
            </svg>
          </button>
          <button class="btn--tiny btn--increase-servings">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-plus-circle"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="recipe__user-generated">
        <svg>
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-user"></use>
        </svg>
      </div>
      <button class="btn--round">
        <svg class="">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-bookmark-fill"></use>
        </svg>
      </button>
    </div>

    <div class="recipe__ingredients">
      <h2 class="heading--2">Recipe ingredients</h2>
      <ul class="recipe__ingredient-list">
      ${this._data.ingredients.map((ingre)=>{
            return `<li class="recipe__ingredient">
      <svg class="recipe__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-check"></use>
      </svg>
      ${ingre.quantity ? `<div class="recipe__quantity">${ingre.quantity}</div>` : ""}
      <div class="recipe__description">
        <span class="recipe__unit">${ingre.unit}</span>
        ${ingre.description}
      </div>
    </li>`;
        }).join("")}                    
      </ul>
    </div>

    <div class="recipe__directions">
      <h2 class="heading--2">How to cook it</h2>
      <p class="recipe__directions-text">
        This recipe was carefully designed and tested by
        <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
        directions at their website.
      </p>
      <a
        class="btn--small recipe__btn"
        href="${this._data.sourceUrl}"
        target="_blank"
      >
        <span>Directions</span>
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-arrow-right"></use>
        </svg>
      </a>
    </div>
    `;
    // recipeContainer.innerHTML = '';
    // recipeContainer.insertAdjacentHTML('afterbegin', markup);
    }
}
var $e95330fac959b1b1$export$2e2bcd8739ae039 = new $e95330fac959b1b1$var$RecipeView();


class $4cb4e5e8d692772b$var$SearchView {
    _parentElement = document.querySelector(".search");
    getQuery() {
        const query = this._parentElement.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }
    _clearInput() {
        this._parentElement.querySelector(".search__field").value = "";
    }
    addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $4cb4e5e8d692772b$export$2e2bcd8739ae039 = new $4cb4e5e8d692772b$var$SearchView();



class $46392c2e8d6932d9$var$ResultsView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "No recipes found. Please try another query!";
    _generateMarkup() {
        return this._data.map((r)=>`<li class="preview">
    <a class="preview__link preview__link--active" href="#${r.id}">
      <figure class="preview__fig">
        <img src="${r.image}" alt="Test" />
      </figure>
      <div class="preview__data">
        <h4 class="preview__title">${r.title}</h4>
        <p class="preview__publisher">${r.publisher}</p>
        <div class="preview__user-generated">
          <svg>
            <use href="src/img/icons.svg#icon-user"></use>
          </svg>
        </div>
      </div>
    </a>
  </li>`).join("");
    }
}
var $46392c2e8d6932d9$export$2e2bcd8739ae039 = new $46392c2e8d6932d9$var$ResultsView();




class $59c1382b4a26248d$var$PaginationView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    _errorMessage = "No recipes found. Please try another query!";
    addHandlerClick(handler) {
        this._parentElement.addEventListener("click", (e)=>{
            console.log("Hey");
            const btn1 = e.target.closest(".btn--inline");
        });
        console.log("btn", btn);
        // const goToPage = btn.dataset.goto;
        // console.log('gotopage', goToPage);
        handler();
    }
    _generateMarkup() {
        const currentPage = this._data.page;
        const pageTotal = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        console.log("pageTotal", pageTotal);
        // Page 1 + no other pages
        // Page 1 + other pages
        // Last page
        // Other pages
        if (currentPage === 1 && pageTotal > 1) return `<button data-goto="${currentPage + 1}" class="btn--inline pagination__btn--next">
      <span>Page ${currentPage + 1}</span>
      <svg class="search__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-arrow-right"></use>
      </svg>
    </button>`;
        if (currentPage === pageTotal && pageTotal) return `<button data-goto="${currentPage - 1}" class="btn--inline pagination__btn--prev">
      <svg class="search__icon">
        <use href=${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-arrow-left"></use>
      </svg>
      <span>Page ${currentPage - 1}</span>
    </button>`;
        if (1 < currentPage < pageTotal) return `<button data-goto="${currentPage - 1}" class="btn--inline pagination__btn--prev">
      <svg class="search__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-arrow-left"></use>
      </svg>
      <span>Page ${currentPage - 1}</span>
    </button>
    <button data-goto="${currentPage + 1}" class="btn--inline pagination__btn--next">
      <span>Page ${currentPage + 1}</span>
      <svg class="search__icon">
        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($cb59c201e168fdfe$exports))}#icon-arrow-right"></use>
      </svg>
    </button>`;
        return "";
    }
}
var $59c1382b4a26248d$export$2e2bcd8739ae039 = new $59c1382b4a26248d$var$PaginationView();


const $f50bd1f2915ed0f2$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $f50bd1f2915ed0f2$var$showRecipes = async function(newURL) {
    try {
        const newURL = window.location.hash.substring(1);
        // prevent error loading if there's no hash
        if (!newURL) return;
        //Load spinner
        (0, $e95330fac959b1b1$export$2e2bcd8739ae039).renderSpinner();
        // Load recipes
        await $0f1d4402dffacf5b$export$b96725c7a035d60b(newURL);
        // Render recipes
        // const recipeView = new RecipeView(model.state.recipe) Same as below
        (0, $e95330fac959b1b1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    // res is undefined. Reference error
    // if (!res.ok) {
    //   throw new Error(`${data.message} (${res.status})`);
    // }
    } catch (err) {
        (0, $e95330fac959b1b1$export$2e2bcd8739ae039).renderError();
    }
};
const $f50bd1f2915ed0f2$var$showResults = async function() {
    try {
        (0, $46392c2e8d6932d9$export$2e2bcd8739ae039).renderSpinner();
        let query = (0, $4cb4e5e8d692772b$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        await $0f1d4402dffacf5b$export$202b8e5cb363a0c4(query);
        // console.log('query', query);
        // ResultsView.render(model.state.search.results);
        (0, $46392c2e8d6932d9$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$b06b94e1e883c50a(3));
        (0, $59c1382b4a26248d$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
    } catch (err) {
        (0, $46392c2e8d6932d9$export$2e2bcd8739ae039).renderError();
    }
};
const $f50bd1f2915ed0f2$var$controlPagination = function() {
    console.log("Page controller");
};
// window.addEventListener('hashchange', showRecipes);
const $f50bd1f2915ed0f2$var$init = ()=>{
    (0, $e95330fac959b1b1$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$showRecipes);
    (0, $4cb4e5e8d692772b$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$showResults);
    (0, $59c1382b4a26248d$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlPagination);
};
//API by Jonas https://forkify-api.herokuapp.com/v2
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.00800664.js.map
